export default class Ajax {
    //開発環境用
    //static url = "http://localhost:8080/beeapi/gannen/v1/";

    //本番環境用
    static url = "https://goisagi.retro-ink.com/beeapi/gannen/v1/";

    static userId = "";
    static setUserId( id:string ){
        Ajax.userId = id;
    }
    static send = (path:string,data:any,func:any)=>{
        //console.log("send",data);

        if( Ajax.userId!=="" ){
            data["userId"] = Ajax.userId;
        }

        //data["text"] = "are you ready?";

        fetch(Ajax.url+path, {
            method : 'POST',
            body : JSON.stringify(data),
            credentials: "include",
        }).then(response => response.json())
        .then((json) => {
            func(json);
        })
        .catch(err => {
            console.log('rejected:', err); // rejected: TypeError: Failed to fetch
        });
    }
}